import { atom } from 'jotai';
import { atomFamily, loadable } from 'jotai/utils';

import request from 'lib/request';
import type { FormulaDetailsResponse } from 'types/api-responses';

/**
 * Lazy-fetches formula details for a single NRI calculation. Consumed by
 * `LazyUnitInterestCard`'s on-expand flow — each `nriCalculationId` gets its
 * own atom and its own cache slot so multiple cards may render simultaneously.
 *
 * Endpoint: `GET /nri_calculations/:id/formula_details`.
 *
 * @param nriCalculationId - The NRI calculation row's id.
 * @return A loadable atom resolving to `FormulaDetailsResponse`.
 */
export const formulaDetailsAtomFamily = atomFamily(
  (nriCalculationId: number) =>
    loadable(
      atom(async (): Promise<FormulaDetailsResponse> => {
        const response = await request.get<FormulaDetailsResponse>(
          `/nri_calculations/${nriCalculationId}/formula_details`
        );

        if ('error' in response) {
          throw new Error((response as { error: string }).error);
        }

        return response;
      })
    ),
  // Equality function for cache key comparison
  (a, b) => a === b
);
